import { createIcon } from '@chakra-ui/react';

export const MbeArrowDropdown = createIcon({
  displayName: 'MbeArrowDropdown',
  viewBox: '0 0 25 25',
  path: (
    <path
      d="M3.375 8.279a.777.777 0 0 1 1.326-.55l7.25 7.266 6.973-6.99a.775.775 0 0 1 1.098 0 .78.78 0 0 1 0 1.1L12.5 16.647a.776.776 0 0 1-1.098 0L3.602 8.83a.777.777 0 0 1-.227-.55"
      fill="#E2001A"
      fillRule="evenodd"
    />
  ),
});
